<template>
  <div class="bto-sb-widget-wrap bto-sb-sport-wrap">
    <div class="bto-sb-widget">
      <div
        class="bto-sb-widget-title bto-sb-title-icon bto-sb-title-big bto-sb-title-breadcrumb"
        v-if="isUS">
        <ul class="bto-sb-breadcrumb">
          <li v-if="sportName">
            <router-link :to="sportRouteLink()">{{ sportName || sport }}</router-link>
          </li>
          <li v-if="sportName && isTournamentPage">
            <router-link :to="getCategrotyRouteLink()">{{ categoryName }}</router-link>
          </li>
        </ul>
        <span
          class="bto-sb-flag bto-sb-flag-oval"
          :class="categoryClass">
        </span>
        <h3>{{ category || tournamentName }}</h3>
        <ToggleFavoriteComponent v-if="SHOW_FAVORITES && isTournamentPage"
          :favType="3"
          :sport="getSport"
          :tournament="matchSports.tabs && matchSports.tabs.length && matchSports.tabs[0]"/>
        <ToggleFavoriteComponent v-else-if="SHOW_FAVORITES"
          :favType="2"
          :sport="getSport"
          :category="matchSports.tabs && matchSports.tabs.length && matchSports.tabs[0]"/>
      </div>
      <div
        class="bto-sb-widget-title bto-sb-title-icon bto-sb-title-big"
        v-if="!isUS">
        <span class="bto-sb-flag bto-sb-flag-oval" :class="categoryName.toLowerCase()"></span>
        <h3>{{ sportName }} - {{ categoryName }}</h3>
        <ToggleFavoriteComponent v-if="SHOW_FAVORITES && isTournamentPage"
          :favType="3"
          :sport="getSport"
          :tournament="matchSports.tabs && matchSports.tabs.length && matchSports.tabs[0]"/>
        <ToggleFavoriteComponent v-else-if="SHOW_FAVORITES"
          :favType="2"
          :sport="getSport"
          :category="matchSports.tabs && matchSports.tabs.length && matchSports.tabs[0]"/>
      </div>
    </div>
    <!------------------------------------- END Title Category ---------------------------------------->
    <!------------------------------------- Widget Prematch Category Nav ---------------------------------------->
    <div class="bto-sb-widget bto-sb-widget-category-nav" v-if="!isUS">
      <div class="bto-sb-widget-content">
        <ul>
          <li @click="changeComp(0)" :class="{ 'bto-sb-category-nav-active': tabIndex === 0 }">
            <a>{{ t("Mobile.LiveNow") }}</a>
          </li>
          <li @click="changeComp(1)" :class="{ 'bto-sb-category-nav-active': tabIndex === 1 }">
            <a>{{ t("Mobile.Competitions") }}</a>
          </li>
          <li @click="changeComp(2)" :class="{ 'bto-sb-category-nav-active': tabIndex === 2 }">
            <a>{{ t("Mobile.Outrights") }}</a>
          </li>
          <li @click="changeComp(3)" :class="{ 'bto-sb-category-nav-active': tabIndex === 3 }">
            <a>{{ t("BO.BoostedOdd") }}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="bto-sb-widget bto-sb-widget-main-nav bto-sb-widget-pills-nav" v-if="isUS">
      <div class="bto-sb-widget-content">
        <div class="bto-sb-scrolling-menu">
          <ul>
            <li @click="changeComp(0)" :class="{ 'bto-sb-main-nav-active': tabIndex === 0 }">
              <a>{{ t("Mobile.LiveNow") }}</a>
            </li>
            <li @click="changeComp(1)" :class="{ 'bto-sb-main-nav-active': tabIndex === 1 }">
              <a>{{ t("Mobile.Competitions") }}</a>
            </li>
            <li @click="changeComp(2)" :class="{ 'bto-sb-main-nav-active': tabIndex === 2 }">
              <a>{{ t("Mobile.Outrights") }}</a>
            </li>
            <li v-if="showBoostedOdds" @click="changeComp(3)" :class="{ 'bto-sb-main-nav-active': tabIndex === 3 }">
              <a>{{ t("BO.BoostedOdd") }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="bto-sb-element" v-if="!isLoading && isUS && tabIndex === 1">
      <empty-state
        v-if="tournamentMatches.length === 0"
        :message="t(emptyStateMsg)"
        :icon-class="emptyStateIcon" />
      <MatchListUsComponent
        v-else
        :sports="sportsList"
        :matchList="tournamentMatches.flatMap((t) => t.matches)"
        :showMarketsInMatch="SHOW_NUMBER_OF_MARKETS"
        :showEventCode="showEventCode"
        :showTeamIcon="showTeamIcon"
        :showFavorites="SHOW_FAVORITES"
        :showStatistics="showStatistics"
        :isLiveSport="false"
        :isInLivesport="false"
        :isCategoryList="true"
        :widgetClass="'bto-sb-widget-matches'" />
    </div>
    <div class="bto-sb-widget bto-sb-widget-category" v-if="!isLoading && tabIndex === 1 && !isUS">
      <empty-state
        v-if="tournamentMatches.length === 0"
        :message="t(emptyStateMsg)"
        :icon-class="emptyStateIcon" />
      <category-tab-component
        v-for="tabIndex in tabIndexes"
        :key="tabIndex"
        :sportIn="matchSports"
        :tabIdx="tabIndex"
        :is3WaySport="matchSports.is3way"
        :markets="[]"
        :isCategoryList="true" />
    </div>
    <div
      class="bto-sb-widget bto-sb-widget-category bto-sb-category-outrights"
      v-if="!isLoading && tabIndex === 2">
      <empty-state
        v-if="tournamentOutrights.length === 0"
        :message="t(emptyStateMsg)"
        :icon-class="emptyStateIcon" />
      <outrights-nav-component v-if="tournamentOutrights.length > 1" :tabs="tournamentOutrights"  v-model="activeTournament" />
      <outrights-tab-component
        v-for="(category, index) in filteredTournamentOutrights"
        :category="category"
        :key="index"
        :isCategoryList="true" />
    </div>
    <live-sport v-if="!isLoading && tabIndex === 0" :isCategory="true" />
    <boosted-odd-widget 
      v-show="tabIndex === 3"
      :showSportFilter="false"
      :displaySlider="false"
      :showTeamFlags="showTeamIcon"
      :embedded="true"
      @showBoostedOdds="checkIfBoostedHaveOdds" />
    <div class="bto-sb-widget bto-sb-widget-category" v-if="isLoading">
      <empty-state :message="t(emptyStateMsg)" :icon-class="emptyStateIcon" />
    </div>
  </div>
</template>
<script>
  import store from '../../../store';
  import LiveSport from './live-sport.vue';
  import { TournamentMatchesListRequestService } from './service-tournament-matches-request';
  import FullSportModel from '../../../models/full-sport-model';
  import CategoryTabComponent from '../category/component-category-tab.vue';
  import OutrightsTabComponent from '../category-outrights/component-outrights-tab.vue';
  import OutrightsNavComponent from '../category-outrights/component-category-outrights-nav.vue';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import MatchListUsComponent from '../../common/match-list-us-component';
  import { LAYOUT_NAME } from '../../../models/enums/layout-const';
  import { urlFriendlyParam } from '@bto-services/utils';
  import { LiveWorker } from "../../../workers";
  import BoostedOddWidget from '@bto-widgets/boosted-odd/src/web';
  import ToggleFavoriteComponent from '../../common/toggle-favorite-component';

  export default {
    name: 'CategoryList',
    components: {
      CategoryTabComponent,
      OutrightsTabComponent,
      EmptyState,
      MatchListUsComponent,
      LiveSport,
      BoostedOddWidget,
      ToggleFavoriteComponent,
      OutrightsNavComponent,
    },
    data() {
      return {
        matchSports: {},
        categoryName: '',
        categoryId: 0,
        sportName: '',
        sportId: 0,
        tabIndex: 1,
        emptyStateIcon: ICON_CLASS.HIGHLIGHTS,
        emptyStateMsg: 'Public.NoEventsAvailable',
        isUS: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
        tournamentName: '',
        showStatistics: APP_SETTINGS.category.showStatistics,
        showEventCode: APP_SETTINGS.category.showEventCode,
        SHOW_NUMBER_OF_MARKETS: APP_SETTINGS.category.showNumberOfMarkets,
        showTeamIcon: APP_SETTINGS.category.showTeamIcon,
        SHOW_FAVORITES: APP_SETTINGS.category.showFavorites,
        showBoostedOdds: false,
        activeTournament: 0,
      };
    },
    watch: {
      '$route'() {
        this.matchSports = {};
        this.loadNewTournaments();
      }
    },
    computed: {
      getSport(){
        return { name: this.sportName, id: this.sportId };
      },
      sport() {
        return this.$route.params.sport;
      },
      categoryClass() {
        if (store.state.SportsModule.categoryMap[this.categoryId]) {
          return store.state.SportsModule.categoryMap[this.categoryId].iClass;
        }
        return store.getters.getSportIconClass(this.sportId);
      },
      isLoading() {
        return this.emptyStateIcon === ICON_CLASS.LOADING;
      },
      category() {
        return this.$route.params.category;
      },
      tournamentMatches() {
        return (this.matchSports.tabs || []).filter(t => t.matches.length > 0);
      },
      sportsList() {
        if (this.matchSports && this.matchSports.id) {
          return [this.matchSports.id];
        }
        return [];
      },
      tabIndexes() {
        return (this.matchSports.tabs || []).map((_, i) => i).filter(i => this.matchSports.tabs[i].matches.length > 0);
      },
      tournamentOutrights() {
        return (this.matchSports.tabs || []).filter(t => t.outrights.length > 0);
      },
      filteredTournamentOutrights() {
        return (this.matchSports.tabs || []).filter(t => {
          if (this.activeTournament !== 0) {
            return t.id === this.activeTournament && t.outrights.length > 0;
          }
          return t.outrights.length > 0
        });
      },
      isTournamentPage() {
        return !!this.$route.params.fixtureIds;
      },
    },
    created() {
      store.commit('hideAfterRouteWidgets');
      this.loadNewTournaments();
      if (typeof this.$route.params.tabIndex !== 'undefined') {
        this.changeComp(this.$route.params.tabIndex);
      }
    },
    destroyed() {
      LiveWorker.removeEventListener('message', this.getDataFromLiveMatch);
    },
    methods: {
      isFavoriteCategory(){        
        const categoryId = this.matchSports && this.matchSports.tabs && this.matchSports.tabs.length && `${this.matchSports.tabs[0].categoryId}`;
        return this.$store.state.favoritesModule.categories.map(t => t.categoryId).findIndex(f => f === categoryId) > -1;
      },
      isFavoriteTournament(){
        const tournamentId = this.matchSports && this.matchSports.tabs && this.matchSports.tabs.length && `${this.matchSports.tabs[0].id}`;
        return this.$store.state.favoritesModule.tournaments.map(t => t.tournamentId).findIndex(f => f === tournamentId) > -1;
      },
      changeComp(item) {
        this.tabIndex = item;
        if (item === 2) {
          const firstTournament = (this.matchSports.tabs || []).find(t => t.outrights.length > 0);
          this.activeTournament = firstTournament ? firstTournament.id : 0;
        }
        this.changeEmptyState(item);
      },
      sportRouteLink() {
        const routeParams = {
          sportName: urlFriendlyParam(this.sportName),
          sportId: this.sportId,
        };

        return { name: 'seoSport', params: routeParams };
      },
      getCategrotyRouteLink() {
        const routeParams = {
          sport: urlFriendlyParam(this.sportName),
          category: urlFriendlyParam(this.categoryName),
          categoryId: this.categoryId,
        };
        return { name: 'seoCategory', params: routeParams };
      },
      changeEmptyState(idx) {
        switch (idx) {
          case -1:
            this.emptyStateIcon = ICON_CLASS.LOADING;
            this.emptyStateMsg = 'Mobile.LoadingMore';
            break;
          case 0:
            this.emptyStateIcon = ICON_CLASS.LIVE;
            this.emptyStateMsg = 'Public.NoLiveMatches';
            break;
          case 2:
            this.emptyStateIcon = ICON_CLASS.OUTRIGHTS;
            this.emptyStateMsg = 'W.NoOutrights';
            break;
          case 1:
          default:
            this.emptyStateIcon = ICON_CLASS.HIGHLIGHTS;
            this.emptyStateMsg = 'Public.NoEventsAvailable';
            break;
        }
      },
      fillDataFromLiveMatch(match) {
        this.categoryName = match.categoryName;
        this.categoryId = match.categoryId;
        this.sportName = match.sportName;
        this.tournamentName = match.tournamentName;
        this.sportId = match.sportId;
        this.changeComp(0);
      },
      getDataFromLiveMatch(msg) {
        if (msg.data.type === 'allLiveMatches') {
          if (this.$route.params.fixtureIds) {
            const match = msg.data.data.lm.find(lm => lm.tournamentId === (+this.$route.params.fixtureIds));
            if (match) {
              this.fillDataFromLiveMatch(match);
              LiveWorker.removeEventListener('message', this.getDataFromLiveMatch);
              return;
            }
          }
          if (this.$route.params.categoryId) {
            const match = msg.data.data.lm.find(lm => lm.categoryId === (+this.$route.params.categoryId));
            if (match) {
              this.fillDataFromLiveMatch(match);
              LiveWorker.removeEventListener('message', this.getDataFromLiveMatch);
            }
          }
        }
      },
      loadNewTournaments() {
        let tournamentMatchesRequest = new TournamentMatchesListRequestService();
        if (this.$route.params.fixtureIds) {
          const fixtureIds = `${this.$route.params.fixtureIds}`.split(',');
          if (this.$route.name === 'seoTournamentGroup') {
            tournamentMatchesRequest.getParams.TournamentGroupData = fixtureIds;
          } else {
            tournamentMatchesRequest.getParams.TournamentData = fixtureIds;
          }
        }
        if (this.$route.params.categoryId) {
          const categoryIds = [this.$route.params.categoryId];
          if (this.$route.name === 'seoCategoryGroup') {
            tournamentMatchesRequest.getParams.CategoryGroupData = categoryIds;
          } else {
            tournamentMatchesRequest.getParams.CategoryData = categoryIds;
          }
        }
        // tournamentMatchesRequest.getParams.TournamentData.push(categoryId.startsWith('t') ? categoryId.replace('t', '') : []);
        // tournamentMatchesRequest.getParams.CategoryData = categoryId.startsWith('t') ? [] : categoryId;
        if (this.$route.params.tabIndex !== 0) {
          this.changeEmptyState(-1);
        }
        this.matchSports = {};

        // send tournament matches request
        tournamentMatchesRequest.execute((response) => {
          /**
           * select outrights tab if no tournament matches are returned
           * and we haven't got any matches from previuos tournaments
           */
          if (!response.data || !response.data.length) {

            LiveWorker.addEventListener('message', this.getDataFromLiveMatch);
            LiveWorker.postMessage({ ev: 'allLiveMatches', resp: {} });
            return;
          }
          // process new data
          const matchSports = response.data.map((s) => {
            let responseSport = new FullSportModel(s);
            // append combi data to sport object
            responseSport.combiMainMarkets = store.state.SportsModule.sportCombos[s.id] || {};
            return responseSport;
          });

          this.matchSports = matchSports[0];
          this.categoryName = this.matchSports.tabs[0].categoryName;
          this.categoryId = this.matchSports.tabs[0].categoryId;
          this.sportName = this.matchSports.name;
          this.sportId = this.matchSports.id;
          this.tournamentName = this.matchSports.tabs[0].tournamentName;

          const hasMatches = this.matchSports.tabs.some(t => t.matches.length > 0);
          // If no there are no matches for any of the tournaments then switch to outrights
          this.changeComp(hasMatches ? 1 : 2);
        }).finally(() => {
          this.changeEmptyState(this.tabIndex);
        });
      },
      checkIfBoostedHaveOdds(flag) {
        this.showBoostedOdds = flag;
      }
    }
  };
</script>
